import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    user: null,
};

const userDetailsSlice = createSlice({
    name : "userDetails",
    initialState,
    reducers:{
        StoreUser : (state , action)=>{
            state.user = action.payload;
        }
    }

})

export const {StoreUser} = userDetailsSlice.actions
export default userDetailsSlice.reducer ;